import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { config } from '../../../config.js';
import { SidebarContext } from '../../../context/SidebarContext';
import SectionMenuLeft from '../../../components/SectionMenuLeft/SectionMenuLeft.jsx';
import { ToastContainer, toast } from 'react-toastify';
import './UpdateDriver.css';
import { LuArrowLeft } from 'react-icons/lu';

function UpdateDriver() {
    const navigate = useNavigate()
    const { isSidebar } = useContext(SidebarContext);
    const { uid } = useParams();
    const [isFetching, setIsFetching] = useState(true);
    const [driver, setDriver] = useState({
        userName: '',
        phoneNumber: '',
        email: '',
        city: '',
        approved: false,
        isActive: false,
        isOnline: false,
        walletBalance: '',
        location: '',
        referenceMobile: '',
        dob: '',
    });

    const [isLoading, setIsLoading] = useState(false);

    const fetchDriver = async () => {
        setIsFetching(true);

        try {
            const response = await fetch(`${config.backEndBaseUrl}driver/get/${uid}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
                },
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const result = await response.json();


            const data = result.driver || result.data?.driver || result.data;
            if (!data) throw new Error('No driver data found in response');

            setDriver({
                userName: data.userName || '',
                phoneNumber: data.phoneNumber || '',
                email: data.email || '',
                city: data.city || '',
                approved: data.approved || false,
                isActive: data.isActive || false,
                isOnline: data.isOnline || false,
                walletBalance: data.walletBalance || '',
                location: data.location || '',
                referenceMobile: data.referenceMobile || '',
                dob: data.dob || '',
            });

        } catch (error) {
            console.error('Error fetching driver:', error);
            toast.error('Failed to fetch driver details');
        } finally {
            setIsFetching(false);

        }
    };

    useEffect(() => {
        fetchDriver();
    }, [uid]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setDriver((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await fetch(`${config.backEndBaseUrl}driver/${uid}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'x-dashboard-request': 'true',
                },
                body: JSON.stringify(driver),
            });

            const result = await response.json();
            if (result.status) {
                toast.success('Driver updated successfully!');
            } else {
                toast.error('Failed to update driver');
            }
        } catch (error) {
            console.error('Error updating driver:', error);
            toast.error('Error updating driver');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="body">
            <div id="wrapper">
                <div id="page">
                    <div className="layout-wrap">
                        <SectionMenuLeft />
                        <div className="section-content-right">
                            <div className="main-content" style={{ paddingLeft: isSidebar ? '280px' : '0px' }}>
                                <div className="main-content-inner">
                                    <div className="wg-box wg-box-container">
                                        <ToastContainer />
                                        {
                                            isFetching ?
                                                <div className="skeleton-wrapper">
                                                    {[...Array(8)].map((_, i) => (
                                                        <div className="skeleton-field" key={i}>
                                                            <div className="skeleton-label"></div>
                                                            <div className="skeleton-input"></div>
                                                        </div>
                                                    ))}
                                                </div> :
                                                <form className="form-new-product form-style-1" onSubmit={handleSubmit}>
                                                    <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                                                        <div className="flex items-center gap-3">
                                                            <button
                                                                className="back-btn flex items-center gap-2"
                                                                onClick={() => navigate("/")}
                                                            >
                                                                <LuArrowLeft size={16} />
                                                                {/* <span>Back</span> */}
                                                            </button>

                                                            <h5 className="fare-heading">Update Driver Form</h5>
                                                        </div>
                                                    </div>
                                                    <fieldset className="name">
                                                        <div className="body-title">Driver Name</div>
                                                        <input
                                                            type="text"
                                                            name="userName"
                                                            value={driver.userName}
                                                            onChange={handleChange}
                                                            placeholder="Driver name"
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Phone Number</div>
                                                        <input
                                                            type="text"
                                                            name="phoneNumber"
                                                            value={driver.phoneNumber}
                                                            readOnly
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Email</div>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            value={driver.email}
                                                            onChange={handleChange}
                                                            placeholder="Email"
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">City</div>
                                                        <input
                                                            type="text"
                                                            name="city"
                                                            value={driver.city}
                                                            onChange={handleChange}
                                                            placeholder="City"
                                                        />
                                                    </fieldset>

                                                    <fieldset>
                                                        <div className="body-title">Approved</div>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                name="approved"
                                                                checked={driver.approved}
                                                                onChange={handleChange}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </fieldset>

                                                    <fieldset>
                                                        <div className="body-title">Active</div>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                name="isActive"
                                                                checked={driver.isActive}
                                                                onChange={handleChange}
                                                            />

                                                            <span className="slider round"></span>
                                                        </label>
                                                    </fieldset>

                                                    <fieldset>
                                                        <div className="body-title">Online</div>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                name="isOnline"
                                                                checked={driver.isOnline}
                                                                onChange={handleChange}
                                                            />

                                                            <span className="slider round"></span>
                                                        </label>
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Wallet Balance (read-only; changes require verified wallet events)</div>
                                                        <input
                                                            type="number"
                                                            name="walletBalance"
                                                            value={driver.walletBalance}
                                                            readOnly
                                                            onChange={handleChange}
                                                            placeholder="Wallet Balance"
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Location</div>
                                                        <input
                                                            type="text"
                                                            name="location"
                                                            value={driver.location}
                                                            onChange={handleChange}
                                                            placeholder="Location"
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Reference Mobile</div>
                                                        <input
                                                            type="text"
                                                            name="referenceMobile"
                                                            value={driver.referenceMobile}
                                                            onChange={handleChange}
                                                            placeholder="Reference Mobile"
                                                        />
                                                    </fieldset>

                                                    <fieldset className="name">
                                                        <div className="body-title">Date of Birth</div>
                                                        <input
                                                            type="text"
                                                            name="dob"
                                                            value={driver.dob}
                                                            onChange={handleChange}
                                                            placeholder="DD/MM/YYYY"
                                                        />
                                                    </fieldset>

                                                    <div className="subBtnCon">
                                                        <button type="submit" className="btn" disabled={isLoading}>
                                                            {isLoading ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </form>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateDriver;
